import { useStore } from '../state/store';
import { useNovelStore } from './ai-novel/novelStore';

/**
 * EmYu-Ba Games カタログ。AI Novel のみプレイ可、他は Coming Soon。
 */
export function GamesHubScreen() {
  const setView = useStore((s) => s.setView);
  const openSetup = useNovelStore((s) => s.openSetup);

  return (
    <div className="library-shell flex h-full flex-col">
      <header className="pt-safe-header shrink-0 border-b border-base-600/60 bg-[#07090f] px-4 pb-3 md:hidden landscape:hidden">
        <h1 className="brand-mark text-lg font-semibold tracking-tight text-white">EmYu-Ba Games</h1>
      </header>

      <div className="mx-auto min-h-0 w-full max-w-2xl flex-1 overflow-y-auto px-4 pb-[calc(5.5rem+env(safe-area-inset-bottom,0px))] pt-4 md:pb-10 landscape:pb-10">
        <p className="field-label !mb-2">Catalog</p>
        <p className="mb-4 text-sm text-slate-400">オリジナルゲームをここから遊べます。</p>

        <ul className="space-y-3">
          <li>
            <button
              type="button"
              onClick={openSetup}
              className="card group w-full p-5 text-left transition-colors hover:border-accent/40"
            >
              <p className="font-display text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-accent">
                Playable
              </p>
              <h2 className="mt-2 text-lg font-semibold text-white">AI Novel</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-400">
                AI が毎回ちがう短編サウンドノベルを生成します。
              </p>
              <span className="btn-primary mt-4 inline-flex !min-h-0 !px-3 !py-1.5 !text-xs">Play</span>
            </button>
          </li>

          <li>
            <div className="card w-full p-5 opacity-80">
              <p className="font-display text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-slate-500">
                Coming Soon
              </p>
              <h2 className="mt-2 text-lg font-semibold text-slate-200">Original Games</h2>
              <p className="mt-1.5 text-sm text-slate-500">EmYu-Ba 発のオリジナルタイトルを準備中です。</p>
            </div>
          </li>

          <li>
            <div className="card w-full p-5 opacity-80">
              <p className="font-display text-[0.65rem] font-semibold uppercase tracking-[0.18em] text-slate-500">
                Coming Soon
              </p>
              <h2 className="mt-2 text-lg font-semibold text-slate-200">Free / Premium</h2>
              <p className="mt-1.5 text-sm text-slate-500">無料・プレミアムの配信枠は今後公開予定です。</p>
            </div>
          </li>
        </ul>

        <button type="button" className="btn-ghost mt-6 w-full sm:w-auto" onClick={() => setView('home')}>
          Home に戻る
        </button>
      </div>
    </div>
  );
}
